import defaultUserPicture from '@/assets/default-user-picture.jpg';

export const ITEMS_PER_PAGE = 200;

export const UserStatusList = [
  {
    value: null,
    langKey: 'ALL_USERS',
  },
  {
    value: true,
    langKey: 'APPROVED_USERS',
  },
  {
    value: false,
    langKey: 'UNAPPROVED_USERS',
  },
];

export const permissionTypes = {
  agency: {
    view: 'agency.view',
  },
  headline: {
    view: 'headline.view',
  },
  headlineOld: {
    view: 'headlineOld.view',
  },
  mailing: {
    view: 'mailing.view',
  },
  story: {
    view: 'story.view',
  },
  storyOld: {
    view: 'storyOld.view',
  },
  storyAd: {
    view: 'storyAd.view',
  },
  content: {
    view: 'content.view',
  },
  news: {
    view: 'news.view',
  },
  video: {
    view: 'video.view',
  },
  photoGallery: {
    view: 'photoGallery.view',
  },
  column: {
    view: 'column.view',
  },
  cartoon: {
    view: 'cartoon.view',
  },
  infographic: {
    view: 'infographic.view',
  },
  promotion: {
    view: 'promotion.view',
  },
  user: {
    view: 'user.view',
  },
  signature: {
    view: 'signature.view',
  },
  chef: {
    view: 'chef.view',
  },
  source: {
    view: 'source.view',
  },
  headlineSettings: {
    view: 'headlineSettings.view',
  },
  headlineCategoryList: {
    view: 'headlineCategoryList.view',
  },
  author: {
    view: 'author.view',
  },
  program: {
    view: 'program.view',
  },
  cartoonist: {
    view: 'cartoonist.view',
  },
  podcast: {
    view: 'podcast.view',
  },
  headlineTag: {
    view: 'headlineTag.view',
  },
  notification: {
    view: 'notification.view',
  },
  featureFlags: {
    view: 'featureFlags.view',
  },
  turboAdvertisement: {
    view: 'turboAdvertisement.view',
  },
  mailingOld: {
    view: 'mailingOld.view',
  },
  liveTransfer: {
    view: 'liveTransfer.view',
  },
  videoProcessQueue: {
    view: 'videoProcessQueue.view',
  },
  editorContentReport: {
    view: 'editorContentReport.view',
  },
  reels: {
    view: 'reels.view',
  },
  seoContents: {
    view: 'seoContents.view',
  },
  brand: {
    view: 'brand.view',
  },
  category: {
    view: 'category.view',
  },
  menu: {
    view: 'menu.view',
  },
  officialAnnouncement: {
    view: 'officialAnnouncement.view',
  },
  agencyArchive: {
    view: 'agencyArchive.view',
  },
  newspaper: {
    view: 'newspaper.view',
  },
  newspaperHeadline: {
    view: 'newspaperHeadline.view',
  },
  comment: {
    view: 'comment.view',
  },
  recipe: {
    view: 'recipe.view',
  },
};

export const DEFAULT_USER_PICTURE = defaultUserPicture;

export const ADMIN_ROLE_ID = '1';
export const SENIOR_EDITOR_ROLE_ID = '6';
